







































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { Component, Prop } from 'vue-property-decorator';
import { MswApiService } from '@/shared/msw-api-service';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { InfoState } from '@/core';
const cssPrefix = 'confirmDeletedDialog';
@Component({
  components:{
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
  },
})
export default class ConfirmDeletedDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showModal: boolean;
  @Prop()
  data: any;
  selectedComponent: string = '';
  heading: any = '';
  innerText: any = '';

  get getWidth() {
    return '500px';
  }

  mounted() {
    this.selectedComponent = this.data.componentName;
    if (this.selectedComponent === 'autorenewal') {
      this.heading = this.$t('autoRenewals.deleteAutoRenewal');
      this.innerText = this.$t('autoRenewals.deleteAlert');
    }
  }
  closeDialog(result: any = {}) {
    this.$emit('close-delete-popup', result);
  }
  onDelete() {
    if (this.selectedComponent === 'autorenewal') {
      const request = {
        autoRenewalId : this.data.hasOwnProperty('autoRenewalID') ? this.data.autoRenewalID : '',
      };
      this.$store.commit('startLoading');
      MswApiService.orders.deleteAutoRenawal(request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res) {
            const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
            this.$store.commit('enqueueMessage', message);
            const result: any = {
              status: 'DELETE_SUCCESSFUL',
            };
            this.closeDialog(result);
          } else {
            const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
            this.$store.commit('enqueueMessage', message);
            this.closeDialog();
          }
        })
        .catch((errResp: any) => {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: errResp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.closeDialog();
        });
    }
  }
}
